// extracted by mini-css-extract-plugin
var _1 = "#68914d";
var _2 = "#9cc681";
var _3 = "#8ab46f";
var _4 = "blank-state___lyy7B";
var _5 = "blank-state-icon___cCy79";
var _6 = "8px";
var _7 = "6px";
var _8 = "8px";
var _9 = "0 1px 1px 0 rgba(0,0,0,.02) inset";
var _a = "0 8px 8px -4px rgba(0,0,0,.03),0 16px 24px -4px rgba(0,0,0,.08)";
var _b = "10px";
var _c = "#e8e8e8";
var _d = "16px 24px";
var _e = "#38aa73";
var _f = "#956c22";
var _10 = "#2988bd";
var _11 = "#eee";
var _12 = "#c4842d";
var _13 = "#b8567c";
var _14 = "#8b6e4e";
var _15 = "#5889c2";
var _16 = "#4e8a8a";
var _17 = "#6a8a3e";
var _18 = "#7b5ea7";
var _19 = "#4a6fa5";
var _1a = "#3a8a6e";
var _1b = "#c25b4e";
var _1c = "#fafbfc";
var _1d = "#1e3050";
var _1e = "#293d62";
var _1f = "#fafbfc";
var _20 = "rgba(0,0,0,.12)";
var _21 = "#d9d9d9";
var _22 = "rgba(5,5,5,.1)";
var _23 = "#eaf2fc";
var _24 = "rgba(0,0,0,.65)";
var _25 = "#ebebeb";
var _26 = "#068467";
var _27 = "rgba(6,132,103,.1)";
var _28 = "#dc4949";
var _29 = "rgba(220,73,73,.1)";
var _2a = "#787c81";
var _2b = "#d6d9dc";
var _2c = "#f3f5f7";
var _2d = "#73c9b2";
var _2e = "linear-gradient(180deg, #73C9B2 0%, #B8E7DA 100%)";
var _2f = "#b8e7da";
var _30 = "#5357f8";
var _31 = "rgb(14.3921787709,19.9877094972,245.2078212291)";
var _32 = "rgb(249.6189944134,249.7441340782,254.7810055866)";
var _33 = "#f7f8f9";
var _34 = "#edeeef";
var _35 = "#7b8996";
var _36 = "#ededed";
var _37 = "#f4f5f7";
var _38 = "#fbfbfc";
var _39 = "rgba(0,0,0,.75)";
var _3a = "rgba(171.2567039106,172.4612273574,220.9432960894,.95)";
var _3b = "rgba(0,0,0,.3)";
var _3c = "rgba(0,0,0,.5)";
var _3d = "rgba(0,0,0,.4)";
var _3e = "rgba(0,0,0,.95)";
var _3f = "rgba(0,0,0,.65)";
var _40 = "rgba(0,0,0,.85)";
var _41 = "20px";
var _42 = "#f41e28";
var _43 = "1063px";
var _44 = "rgba(227,89,86,.2)";
var _45 = "#e35956";
var _46 = "16px 24px";
var _47 = "28px";
var _48 = "32px";
var _49 = "18px";
var _4a = "14px";
var _4b = "14px";
var _4c = "15px";
var _4d = "12.6px";
var _4e = "11px";
var _4f = "20px";
var _50 = "28px";
var _51 = "700";
var _52 = "200";
var _53 = "300";
var _54 = "500";
var _55 = "400";
var _56 = "600";
var _57 = "hsla(0,0%,100%,.2)";
var _58 = "#ccc";
var _59 = "49px";
var _5a = "5px";
var _5b = "#5357f8";
var _5c = "rgba(0,0,0,.4)";
var _5d = "load-more___vGI9n";
var _5e = "menu___kRYXM";
var _5f = "menu-title___mAfgT";
var _60 = "#fafafa";
var _61 = "hsla(0,0%,100%,.9)";
var _62 = "15px";
var _63 = "20px";
var _64 = "24px";
var _65 = "selected-options___penpj";
var _66 = "selected-options-divider___lqMH6";
var _67 = "hsla(0,0%,100%,.6)";
var _68 = "#7e7eff";
var _69 = "hsla(0,0%,100%,.7)";
var _6a = "hsla(0,0%,100%,.3)";
var _6b = "hsla(0,0%,100%,.575)";
var _6c = "60px";
var _6d = "208px";
var _6e = "rgba(82,196,26,.2)";
var _6f = "#52c41a";
var _70 = "12px";
var _71 = "20px";
var _72 = "tag___b1ZIq";
var _73 = "typeahead___YdAxr";
var _74 = "typeahead-item___QgWbI";
var _75 = "typeahead-item-option-active___JIuJ1";
var _76 = "typeahead-item-option-disabled___GMH7I";
var _77 = "typeahead-item-option-selected___dC28P";
var _78 = "typeahead-menu-item-label___uYJNc";
var _79 = "typeahead-menu-item-to-be-created___ttkJ5";
var _7a = "rgba(250,173,20,.2)";
var _7b = "#faad14";
var _7c = "#fff";
var _7d = "hsla(0,0%,100%,.2)";
export { _1 as "actionButtonColorDark", _2 as "actionButtonColorLight", _3 as "actionButtonColorMedium", _4 as "blank-state", _5 as "blank-state-icon", _6 as "borderRadiusCard", _7 as "borderRadiusMain", _8 as "borderRadiusSurface", _9 as "boxShadowInnerXs", _a as "boxShadowXl", _b as "btnRightMargin", _c as "cardBorderColor", _d as "cardPadding", _e as "changeSetCompletedColor", _f as "changeSetManuallyChangesProposed", _10 as "changeSetScheduledChangesProposed", _11 as "chipBackground", _12 as "colorAccentAmber", _13 as "colorAccentBerry", _14 as "colorAccentBrown", _15 as "colorAccentCornflower", _16 as "colorAccentCyan", _17 as "colorAccentOlive", _18 as "colorAccentPurple", _19 as "colorAccentSteelBlue", _1a as "colorAccentTeal", _1b as "colorAccentTerracotta", _1c as "colorBackgroundMain", _1d as "colorBackgroundSidebar", _1e as "colorBackgroundSidebarHover", _1f as "colorBackgroundTabs", _20 as "colorBorderContainer", _21 as "colorBorderMain", _22 as "colorBorderSecondary", _23 as "colorDeltaCyanBlueBg", _24 as "colorDeltaGray", _25 as "colorDeltaGrayBg", _26 as "colorDeltaGreen", _27 as "colorDeltaGreenBg", _28 as "colorDeltaRed", _29 as "colorDeltaRedBg", _2a as "colorDetailsFieldText", _2b as "colorDetailsIcon", _2c as "colorDetailsTagBg", _2d as "colorMint", _2e as "colorMintGradient", _2f as "colorMintLight", _30 as "colorPrimary", _31 as "colorPrimaryHover", _32 as "colorPrimaryLightened", _33 as "colorTableHeadBg", _34 as "colorTableHeadBgHover", _35 as "colorTableHeadSubtitle", _36 as "colorTableRowBorder", _37 as "colorTableTextBg", _38 as "colorTableTotalRowBg", _39 as "colorTextBase", _3a as "colorTextDisabled", _3b as "colorTextExtraLight", _3c as "colorTextLight", _3d as "colorTextLighter", _3e as "colorTextMainHeading", _3f as "colorTextMuted", _40 as "colorTextPrimary", _41 as "contentHorizPadding", _42 as "dangerColor", _43 as "dashboardPdfContentWidth", _44 as "errorBackcolor", _45 as "errorColor", _46 as "filterPanelPadding", _47 as "filtersDefaultHeight", _48 as "filtersTallHeight", _49 as "fontSizeLarge", _4a as "fontSizeMain", _4b as "fontSizeMedium", _4c as "fontSizePlus", _4d as "fontSizeSmaller", _4e as "fontSizeSmallest", _4f as "fontSizeXLarge", _50 as "fontSizeXxLarge", _51 as "fontWeightBold", _52 as "fontWeightExtraLight", _53 as "fontWeightLight", _54 as "fontWeightMediumBold", _55 as "fontWeightNormal", _56 as "fontWeightSemiBold", _57 as "ghostWhite", _58 as "grayBackgroundColor", _59 as "headerHeight", _5a as "iconHorizontalMargin", _5b as "linkColor", _5c as "linkColorMuted", _5d as "load-more", _5e as "menu", _5f as "menu-title", _60 as "popoverHeaderColor", _61 as "popoverMaskColor", _62 as "rowPadding", _63 as "ruleInnerGutters", _64 as "ruleSideGutters", _65 as "selected-options", _66 as "selected-options-divider", _67 as "sideMenuIconColor", _68 as "sideMenuIconSelectedColor", _69 as "sideMenuItemColor", _6a as "sideMenuScrollbarThumbColor", _6b as "sideMenuSubmenuItemColor", _6c as "sidebarCollapsedWidth", _6d as "sidebarWidth", _6e as "successBackcolor", _6f as "successColor", _70 as "tableHeaderVerticalPadding", _71 as "tableHorizPadding", _72 as "tag", _73 as "typeahead", _74 as "typeahead-item", _75 as "typeahead-item-option-active", _76 as "typeahead-item-option-disabled", _77 as "typeahead-item-option-selected", _78 as "typeahead-menu-item-label", _79 as "typeahead-menu-item-to-be-created", _7a as "warningBackcolor", _7b as "warningColor", _7c as "whiteColor", _7d as "whiteDividerColor" }
